<template>
  <div class="p-main">
    <div class="p-main__left">
      <side-nav />
    </div>
    <div class="p-main__right">
      <div class="p-main__right__bar">
        <div v-if="userInfo" class="p-main__right__user">
          <nav-bar />
          <user-info :user-name="userInfo.email" @detail="handleAccountDetail" @updatePsw="handleUpdatePsw" />
        </div>
      </div>
      <div v-loading="loading" class="p-main__right__content">
        <div v-if="title" class="p-main__right__content__title">{{ title }}</div>
        <router-view
          @loading="handleLoadingStatus(true)"
          @cancelLoading="handleLoadingStatus(false)"
        />
      </div>
    </div>

    <data-export-center ref="exportCenter" />
    <button
      v-if="serviceEntryVisible"
      class="p-main__service-entrance"
      type="button"
      aria-label="在线咨询"
      @click="handleServiceShow"
    >
      <svg
        class="p-main__service-entrance-icon"
        viewBox="0 0 1024 1024"
        aria-hidden="true"
      >
        <path
          d="M983.199516 313.600729a511.508046 511.508046 0 0 0-109.828458-163.77126 506.388051 506.388051 0 0 0-163.428404-110.05703A507.325193 507.325193 0 0 0 512 0.001051h-2.285712c-69.142786 0.342857-135.99986 14.057128-198.971224 41.02853a507.519479 507.519479 0 0 0-161.942691 110.285601 508.570906 508.570906 0 0 0-108.571317 163.199832A514.159472 514.159472 0 0 0 1.143382 514.400523c0.342857 79.314204 19.314266 158.056981 54.742801 228.456909v173.714107c0 29.028542 23.542833 52.571375 52.457089 52.571374h173.485536a511.679475 511.679475 0 0 0 227.999766 54.857087h2.399997c68.342787 0 134.514148-13.257129 196.914084-39.19996A506.513766 506.513766 0 0 0 871.99963 876.000152c47.085666-46.742809 84.114199-101.371324 110.05703-162.285548 26.857115-63.08565 40.571387-130.171295 40.914244-199.428366 0.228571-69.599929-13.257129-137.142716-39.771388-200.685509zM283.885949 566.857612c-30.171398 0-54.742801-24.571403-54.742801-54.857086s24.571403-54.857087 54.742801-54.857087 54.742801 24.571403 54.7428 54.857087-24.457118 54.857087-54.7428 54.857086z m228.114051 0c-30.171398 0-54.742801-24.571403-54.742801-54.857086s24.571403-54.857087 54.742801-54.857087 54.742801 24.571403 54.742801 54.857087-24.571403 54.857087-54.742801 54.857086z m228.114051 0c-30.171398 0-54.742801-24.571403-54.7428-54.857086s24.571403-54.857087 54.7428-54.857087 54.742801 24.571403 54.742801 54.857087-24.571403 54.857087-54.742801 54.857086z"
        />
      </svg>
      <span class="p-main__service-entrance-tip">
        Hi~我在线，欢迎您随时咨询
      </span>
    </button>
    <online-consultation-dialog v-model="consultationVisible" />
  </div>
</template>

<script>
import DataExportCenter from '@component/data-export-center/index';
import SideNav from '@component/sideNav/index';
import NavBar from '@component/navBar/index';
import UserInfo from '@component/userInfo/index';
import OnlineConsultationDialog from './online-consultation-dialog';
import loadingMixin from '@/mixins/loading';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    SideNav,
    UserInfo,
    NavBar,
    DataExportCenter,
    OnlineConsultationDialog
  },
  mixins: [loadingMixin],
  data() {
    return {
      consultationVisible: false
    };
  },
  computed: {
    ...mapState({
      customInfo: (state) => state.account.customInfo,
    }),
    ...mapGetters({
      userInfo: 'account/accountInfo'
    }),
    title() {
      if (this.$route.meta.isSubAccount) return;
      return this.$route.meta.title;
    },
    serviceEntryVisible() {
      const {
        customBrandEnabled,
        customerToolEnabled
      } = this.customInfo || {};
      if (!customBrandEnabled && !customerToolEnabled) return false;

      const customBrand = this.ynToBool(customBrandEnabled || 'N');
      return !customBrand || this.ynToBool(customerToolEnabled || 'N');
    }
  },

  watch: {
    serviceEntryVisible(visible) {
      if (!visible) this.consultationVisible = false;
    }
  },
  mounted() {
    this.getBillDictionary();
  },
  methods: {
    async getBillDictionary() {
      const billDictionary = await this.$store.dispatch('account/getBillDictionary');
      this.$store.commit('account/setBillDictionary', billDictionary);
    },
    handleServiceShow() {
      if (!this.serviceEntryVisible) return;
      this.consultationVisible = true;
    },
    handleAccountDetail() {
      this.$router.push('/group/accountDetail');
    },
    handleUpdatePsw() {
      this.$router.push('/group/updatePassword');
    },
  }

};
</script>

<style lang="scss" scoped>
.p-main {
  min-width: 1170px;
  height: 100%;
  display: flex;
  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    // overflow: scroll;
    &__bar {
      height: 56px;
      position: relative;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
      background: #fff;
      z-index: 1;
    }
    &__content {
      flex: 1;
      background: #fff;
      overflow: scroll;
      box-sizing: border-box;
      position: relative;
      &__title {
        font-size: 18px;
        font-weight: 500;
        margin: 18px;
      }
    }
    &__user {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &__service-entrance {
    position: fixed;
    right: 20px;
    bottom: 40px;
    z-index: 2147483647;
    width: 50px;
    height: 50px;
    padding: 0;
    text-align: center;
    background: transparent;
    border: 0;
    cursor: pointer;
    outline: none;
  }
  &__service-entrance-icon {
    display: block;
    width: 50px;
    height: 50px;
    fill: #0f92ed;
  }
  &__service-entrance-tip {
    display: none;
    position: absolute;
    top: 10px;
    right: 55px;
    height: 30px;
    padding: 0 5px;
    overflow: hidden;
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      'Helvetica Neue',
      Arial,
      'Noto Sans',
      sans-serif,
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji';
    font-size: 13px;
    line-height: 30px;
    color: #555556;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
    background: #fff;
    border: 1px solid #ebeff0;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(107, 113, 114, .15);
    pointer-events: none;
  }
  &__service-entrance:hover &__service-entrance-tip,
  &__service-entrance:focus-visible &__service-entrance-tip {
    display: block;
  }
}
</style>
